<template>
  <div
    class="code-block c-code-block__pre relative"
    :data-lang="node.attrs.language"
    spellcheck="false"
  >
    <div class="absolute bottom-4 right-10" contenteditable="false">
      <button class="relative" @click="showLanguages = !showLanguages">
        <div class="flex items-center text-grey-250 text-12">
          <i class="icon-keyboard-arrow-down mr-5" />
          <p>{{ currentLang }}</p>
        </div>

        <div v-if="showLanguages" class="absolute z-10 top-full -right-10 bg-primary rounded-4 shadow">
          <div class="cursor-default">
            <div class="w-150 max-h-200 overflow-y-auto p-6 text-left">
              <div
                v-for="language in languages"
                :key="language.value"
                class="mx-4 my-5 cursor-pointer text-14"
                @click.stop="setLanguage(language)"
              >
                {{ language.label }}
              </div>
            </div>
          </div>
        </div>
      </button>
    </div>
    <pre class="c-code-block__pre"><NodeViewContent as="code" class="c-code-block__code" /></pre>
  </div>
</template>

<script>
import languages from '@/core/code-languages'
import NodeViewContent from '@/tiptap/utils/NodeViewContent'

export default {
  components: { NodeViewContent },

  props: {
    node: { type: Object },
    updateAttributes: { type: Function }
  },

  data () {
    return {
      showLanguages: false,
      currentLang: 'Auto Detection',
      languages: languages
    }
  },

  created () {
    const lang = languages.find(item => item.value === this.node.attrs.language)

    this.currentLang = lang?.label || 'Auto Detection'
  },

  methods: {
    setLanguage (language) {
      this.updateAttributes({ language: language.value })
      this.currentLang = language.label
      this.showLanguages = false
    }
  }
}
</script>
